import { useParams } from 'react-router'
import { logout as logoutHelper } from '@/lib/auth'
import { defaultLocale } from '@/lib/locales'

/**
 * Hook de déconnexion user-initiated complet :
 * - Invalide le refresh token côté serveur (fire-and-forget via store.clear())
 * - Reset PostHog
 * - Purge AGRESSIVE de localStorage (sauf UI prefs) + sessionStorage + cookies
 * - Notifie le shell macOS (WKWebView cache purge)
 * - Hard reload vers /login (window.location.href, pas navigate)
 *
 * Utiliser ce hook pour tout bouton "Se déconnecter". Garantit qu'aucune
 * donnée user-spécifique ne reste sur le device pour le user suivant.
 */
export function useLogout() {
  const { locale = defaultLocale } = useParams<{ locale: string }>()
  return () => logoutHelper(`/${locale}/login`)
}
